import React from "react";
import {
  DatePicker,
  Select,
  Button,
  Space,
  Row,
  Col,
  message,
  Tooltip,
  Modal,
  Image,
  Dropdown,
  Avatar,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CarOutlined, CloseOutlined, SearchOutlined } from "@ant-design/icons";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import JobRequestStore from "../store/JobRequestStore";
import DepartmentStore from "../store/DepartmentStore";
import JobTypeStore from "../store/JobTypeStore";
import CompanyStore from "../store/CompanyStore";
import JobRequestAdd from "./JobRequestAdd";
import AssignVehicleToJobRequest from "./AssignVehicleToJobRequest";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import dayjs from "dayjs";

// const currentDate = moment().format("YYYY-MM-DD");
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 230;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 130;
    } else if (val.title?.length > 8) {
      val.width = 110;
    } else {
      val.width = 95;
    }
    // console.log(val.title.length)
  });

  return arr;
};
class JobRequestList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.jobRequestStore = new JobRequestStore(this);
    this.departmentStore = new DepartmentStore(this);
    this.jobTypeStore = new JobTypeStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      companyId: "",
      jobId: "",
      jobrequestDateFrom: "",
      jobrequestDateTo: "",
      jobTypeId: "",
      departmentId: "",
      companyVal_Lab: "",
      Id: "",
      openJobRequestForm: false,
      listDataUpdate: false,
      companyFieldHighlight: false,
      openAssignForm: false,
      assignId: "",
      openDeleteModal: false,
      deleteData: {},
      total: null,
      pending: null,
      processed: null,
      finish: null,
      TotalJob: 0,
      TotalPendingJob: 0,
      TotalProcessedJob: 0,
      TotalFinishedJob: 0,
    };

    this.columns = widthAdderFunc([
      {
        // title: "Department Name",
        title: context.translate("_DEPARTMENT_NAME_"),
        dataIndex: "departmentName",
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("jobrequestlist") && this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
        // width: '15%'
      },
      {
        // title: "Job Type",
        title: context.translate("_JOB_TYPE_"),
        dataIndex: "jobName",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%',
      },
      {
        // title: "Contact Person",
        title: context.translate("_CONTACT_PERSON_"),
        dataIndex: "contactPerson",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Contact No",
        title: context.translate("_CONTACT_NO_"),
        dataIndex: "contactNo",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Address",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_ADDRESS_"),
        dataIndex: "location",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => (
          <Tooltip placement="topLeft" title={value}>
            {value}
          </Tooltip>
        ),
        // width: '15%',
      },
      {
        // title: "Invoice Number",
        title: context.translate("_INVOICE_NUMBER_"),
        dataIndex: "invoiceNo",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Invoice Amount",
        title: context.translate("_INVOICE_AMOUNT_"),
        dataIndex: "invoiceAmt",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Request Date",
        title: context.translate("_REQUEST_DATE_"),
        dataIndex: "requestDate",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Request Time",
        title: context.translate("_REQUEST_TIME_"),
        dataIndex: "requestTime",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Vehicle No",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Driver Name",
        title: context.translate(
          "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
        ),
        dataIndex: "name",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Allocate At",
        title: context.translate("_ALLOCATE_AT_"),
        dataIndex: "allocateAt",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Status ",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "status",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
        render: (val) => {
          if (val === 1) {
            return "Pending";
          } else if (val === 3) {
            return "Processed";
          }
        },
      },
      {
        // title: "Finished At ",
        title: context.translate("_FINISHED_AT_"),
        dataIndex: "finishedAt",
        ellipsis: {
          showTitle: true,
        },
        // width: '15%'
      },
      {
        // title: "Action",
        title: context.translate("_ACTION_"),
        dataIndex: "groupname",
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        render: (_, record) => {
          // console.log(record.Id)
          return (
            <>
              <Space>
                <Link
                  onClick={() =>
                    this.setState({ openAssignForm: true, assignId: record.Id })
                  }
                >
                  <Tooltip
                    // title="Assign"
                    title={this.context.translate("_ASSIGN_")}
                    placement="bottom"
                    // color="green"
                  >
                    <CarOutlined
                      style={{ fontSize: "15px", marginTop: "5px" }}
                    />
                  </Tooltip>
                </Link>
                {this.props.canDelete("jobrequestlist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}

                <Dropdown
                  // overlayClassName="export-dropdown"
                  menu={this.actionColumn}
                  trigger={["click"]}
                  style={{ cursor: "pointer" }}
                >
                  <Image
                    src={kebabIcon}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ editData: record });
                    }}
                  ></Image>
                </Dropdown>

                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete"
                      title={context.translate(
                        "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                      )}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm>

                <Link

                  onClick={() =>
                    this.setState({ openAssignForm: true, assignId: record.Id })
                  }
                >
                  <Tooltip
                    // title="Assign"
                    title={this.context.translate("_ASSIGN_")}
                    placement="bottom"
                    color="green"
                  >
                    <CarOutlined />
                  </Tooltip>
                </Link> */}
              </Space>
            </>
          );
        },
      },
    ]);
    this.actionColumn = {
      items: [
        this.props.canUpdate("jobrequestlist") && {
          // label: "Excel",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
                onClick={() => this.onEdit(this.state.editData)}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
          // icon: (

          // ),
        },
      ],
    };
  }
  onEdit = async (record) => {
    console.log(record.Id);
    const id = record.Id;
    if (id) {
      console.log(record.companyId);
      await this.context.viewStateStore.setJobRequestStates(record.companyId);

      await this.setState({ Id: record.Id });
      await this.setState({ openJobRequestForm: true });
    }
  };

  onDelete = async (record) => {
    console.log(record);
    const response = await this.jobRequestStore.deleteRecord({
      companyId: record.companyId,
      Id: record.Id,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  };

  async componentDidUpdate(prvProp, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setJobData = this.context.viewStateStore.jobRequestObject.companyId;
      console.log(setJobData, "setJobData");
      if (setJobData.companyId !== "") {
        const singleData = await this.companyStore.getCompanyDataById(
          setJobData.companyId
        );
        console.log(singleData, "singleData");
        await this.setState({
          companyVal_Lab: singleData,

          companyId: setJobData.companyId,
        });
        await this.jobRequestStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,

          companyId: setJobData.companyId,
        });

        await this.setState({ loadList: 1 });
      }

      await this.setState({ listDataUpdate: false });
    }
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevState.listDataUpdate !== this.state.listDataUpdate) {
  //     var setJobData = this.context.viewStateStore.jobRequestObject;
  //     setJobData =
  //       typeof setJobData === "number" ? setJobData : setJobData.companyId;
  //     if (setJobData !== "") {
  //       await this.jobRequestStore.loadData({
  //         offset: (this.state.currentPage - 1) * this.state.pageSize,
  //         limit: this.state.pageSize,
  //         companyId: setJobData,
  //       });

  //       const singleData = await this.companyStore.getCompanyDataById(
  //         setJobData
  //       );

  //       console.log(first)
  //       await this.setState({ loadList: 1 });

  //       await this.setState({
  //         companyVal_Lab: singleData,
  //         companyId: setJobData,
  //       });
  //     }
  //     await this.setState({ listDataUpdate: false });
  //   }
  // }
  async componentDidMount() {
    // console.log("object")
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    await this.departmentStore.getDepartmentData();
    await this.jobTypeStore.getJobTypeData();
    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }
  async handleChange(comp) {
    await this.setState({ companyId: comp.value, departmentId: "", jobId: "" });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ companyVal_Lab: singleData });
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.jobRequestStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      jobTypeId: this.state.jobId,
      departmentId: this.state.departmentId,
      jobrequestDateFrom: this.state.jobrequestDateFrom,
      jobrequestDateTo: this.state.jobrequestDateTo,
      proceesed: this.state.proceesed,
      finish: this.state.finish,
      pending: this.state.pending,
    });
    await this.setState({ loadList: 1 });
  }

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openJobRequestForm: false });
    } else {
      message.error(resp.message);
    }
  };

  assignresponseMsg = async (resp) => {
    console.log(resp);
    if (resp.data.success === "S") {
      message.success(resp.data.message);
      await this.setState({ Id: [] });
      await this.setState({ listDataUpdate: true });
      await this.setState({ openAssignForm: false });

      await this.handleSearch();
    } else {
      message.error(resp.data.message);
    }
  };

  async searchClick() {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }

    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      // this.setState({  });

      await this.jobRequestStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        jobTypeId: this.state.jobId,
        departmentId: this.state.departmentId,
        jobrequestDateFrom: this.state.jobrequestDateFrom,
        jobrequestDateTo: this.state.jobrequestDateTo,
        proceesed: this.state.processed,
        finish: this.state.finish,
        pending: this.state.pending,
      });

      await this.setState({
        TotalJob: this.jobRequestStore?.jobState?.TotalJob
          ? this.jobRequestStore?.jobState?.TotalJob
          : 0,
        TotalPendingJob: this.jobRequestStore?.jobState?.TotalPendingJob
          ? this.jobRequestStore?.jobState?.TotalPendingJob
          : 0,
        TotalProcessedJob: this.jobRequestStore?.jobState?.TotalProcessedJob
          ? this.jobRequestStore?.jobState?.TotalProcessedJob
          : 0,
        TotalFinishedJob: this.jobRequestStore?.jobState?.TotalFinishedJob
          ? this.jobRequestStore?.jobState?.TotalFinishedJob
          : 0,
      });

      await this.setState({ loadList: 1 });
    }
  }
  closeModal = () => {
    this.setState({ openJobRequestForm: false, Id: "" });
  };
  closeModalAssign = () => {
    this.setState({ openAssignForm: false });
  };
  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.jobRequestStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
        proceesed: this.state.processed,
        finish: this.state.finish,
        pending: this.state.pending,
        jobTypeId: "",
        departmentId: "",
        jobrequestDateFrom: "",
        jobrequestDateTo: "",
      });

      await this.setState({
        TotalJob: this.jobRequestStore?.jobState?.TotalJob
          ? this.jobRequestStore?.jobState?.TotalJob
          : 0,
        TotalPendingJob: this.jobRequestStore?.jobState?.TotalPendingJob
          ? this.jobRequestStore?.jobState?.TotalPendingJob
          : 0,
        TotalProcessedJob: this.jobRequestStore?.jobState?.TotalProcessedJob
          ? this.jobRequestStore?.jobState?.TotalProcessedJob
          : 0,
        TotalFinishedJob: this.jobRequestStore?.jobState?.TotalFinishedJob
          ? this.jobRequestStore?.jobState?.TotalFinishedJob
          : 0,
      });

      this.setState({
        loading: false,
        currentPage: 1,
        jobId: "",
        departmentId: "",
        jobrequestDateFrom: "",
        jobrequestDateTo: "",
      });
      await this.setState({ loadList: 1 });
    }
  };
  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "1.5px solid red", width: "150px", borderRadius: "25px" }
      : { width: "150px" };
    const ExportMenuProps2 = {
      items: [
        {
          label: this.context.translate("_TOTAL_") + " " + this.state.TotalJob,
          key: "total",
        },
        {
          label:
            this.context.translate("_PENDING_") +
            " " +
            this.state.TotalPendingJob,
          key: "pending",
        },
        {
          label:
            this.context.translate("_PROCESSED_") +
            " " +
            this.state.TotalProcessedJob,
          key: "processed",
        },
        {
          label:
            this.context.translate("_FINISHED_") +
            " " +
            this.state.TotalFinishedJob,
          key: "finished",
        },
      ],
      onClick: async (val) => {
        if (val.key == "total") {
          await this.setState({
            finish: null,
            proceesed: null,
            pending: null,
          });
          await this.handleSearch();
        } else if (val.key == "pending") {
          await this.setState({
            pending: 1,
            proceesed: null,
            finish: null,
          });
          await this.handleSearch();
        } else if (val.key == "processed") {
          await this.setState({
            proceesed: 3,
            pending: null,
            finish: null,
          });
          await this.handleSearch();
        } else if (val.key == "finished") {
          await this.setState({
            finish: 4,
            proceesed: null,
            pending: null,
          });
          await this.handleSearch();
        }
      },
    };

    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={18}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  onBlur={() => {
                    if (this.state.companyId) {
                      this.setState({ companyFieldHighlight: false });
                    }
                  }}
                  style={companyInputBox}
                />

                <Select
                  className="searchInput"
                  value={
                    this.state.departmentId ? this.state.departmentId : null
                  }
                  placeholder={this.context.translate("_SELECT_DEPARTMENT_")}
                  onSelect={async (val) => {
                    await this.setState({ departmentId: val });
                  }}
                  style={{ width: 170 }}
                  onSearch={async () => await this.handleSearch()}
                  showSearch
                  fieldNames={{
                    value: "departmentId",
                    label: "departmentName",
                  }}
                  optionFilterProp="children"
                  options={this.departmentStore?.departments}
                />
                <Select
                  className="searchInput"
                  value={this.state.jobId ? this.state.jobId : null}
                  placeholder={this.context.translate("_SELECT_JOB_TYPE")}
                  style={{ width: 150, borderRadius: "25px" }}
                  onSelect={async (val) => {
                    await this.setState({ jobId: val });
                  }}
                  onSearch={async () => await this.handleSearch()}
                  showSearch
                  fieldNames={{ value: "jobId", label: "jobName" }}
                  optionFilterProp="children"
                  options={this.jobTypeStore?.jobTypeList}
                />
                <DatePicker
                  value={
                    this.state.jobrequestDateFrom
                      ? dayjs(this.state.jobrequestDateFrom)
                      : null
                  }
                  className="searchInput"
                  placeholder={this.context.translate("_FROM_DATE_")}
                  style={{ width: 130, borderRadius: "25px" }}
                  name="jobrequestDateFrom"
                  onChange={(date) => {
                    if (date === null) {
                      this.setState({ jobrequestDateFrom: "" });
                    } else {
                      const format = "YYYY-MM-DD";
                      this.setState({
                        jobrequestDateFrom: date.format(format),
                      });
                    }
                  }}
                />

                <DatePicker
                  value={
                    this.state.jobrequestDateTo
                      ? dayjs(this.state.jobrequestDateTo)
                      : null
                  }
                  className="searchInput"
                  placeholder={this.context.translate("_TO_DATE_")}
                  style={{ width: 130, borderRadius: "25px" }}
                  name="jobrequestDateTo"
                  onChange={(date) => {
                    console.log(date);
                    if (date === null) {
                      this.setState({ jobrequestDateTo: "" });
                    } else {
                      const format = "YYYY-MM-DD";
                      this.setState({ jobrequestDateTo: date.format(format) });
                    }
                  }}
                />
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={async () => {
                    await this.setState({
                      finish: null,
                      proceesed: null,
                      pending: null,
                    });
                    await this.searchClick();
                  }}
                >
                  {/* <SearchOutlined /> */}
                </Button>
              </Space>
            </Col>

            <Col span={6}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "30px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Dropdown
                  overlayClassName="export-dropdown"
                  menu={ExportMenuProps2}
                >
                  <Image
                    style={{ height: 18, alignItems: "center" }}
                    src={kebabIcon}
                  ></Image>
                </Dropdown>
                {this.props.canCreate("jobrequestlist") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({ openJobRequestForm: true, id: "" })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.jobRequestStore?.total}
            columns={this.columns}
            dataSource={this.jobRequestStore?.jobRequest}
            loading={this.jobRequestStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.openJobRequestForm && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openJobRequestForm}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_JOB_REQUEST_")}
                  <p className="formDescription">
                    {this.context.translate("_JOB_REQUEST_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openJobRequestForm: false })}
              onCancel={() =>
                this.setState({ openJobRequestForm: false, id: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <JobRequestAdd
                  Id={this.state.Id}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}

          {this.state.openAssignForm && (
            // <Modal
            //   bodyStyle={{ height: "645px" }}
            //   className="formShowModal" //  {/* css class */}
            //   // title="Assign Vehicle To Job Request"
            //   title={this.context.translate("_ASSIGN_VEHICLE_TOJOB_REQ_")}
            //   centered
            //   visible={this.state.openAssignForm}
            //   footer={null}
            //   onCancel={() => {
            //     this.setState({ openAssignForm: false });
            //   }}
            //   width={665}
            // >
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              // title={this.context.translate("_ADD_NEW_VEHICLE_")}
              open={this.state.openAssignForm}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              maskClosable={false}
              onOk={() => this.setState({ openAssignForm: false })}
              onCancel={() => this.setState({ openAssignForm: false })}
              title={
                <div className="formTitle">
                  {this.context.translate("_FLEET_USER_USERLIST_VEHICLE_")}
                  <p className="formDescription">
                    {this.context.translate("_ASSIGN_VEHICLE_FORM_DESC_")}
                  </p>
                </div>
              }
            >
              <div>
                <AssignVehicleToJobRequest
                  companyId={this.state.companyId}
                  ID={this.state.assignId}
                  response={this.assignresponseMsg}
                  closeModalAssign={this.closeModalAssign}
                />
              </div>
              {/* // </Modal> */}
            </Drawer>
          )}
        </div>

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
JobRequestList.contextType = StoreContext;
export default observer(withRouter(JobRequestList));
